import { CloseCircle } from 'entities/close-circle/model'

import { TYPE_AGE_BEKET } from 'shared/constants'

import { BeketPassengersValue } from '../models/form-passengers'

interface Props {
  closeCircle: CloseCircle
  isAbroad?: boolean
  isChild?: boolean
}

export const preparePassengerByCloseCircle = ({
  closeCircle,
  isAbroad,
  isChild,
}: Props) => {
  const preparedData: BeketPassengersValue = {
    id: closeCircle?.id,
    lastName: closeCircle?.last_name,
    firstName: closeCircle?.first_name,
    tariff: isChild ? TYPE_AGE_BEKET.CHILDREN : TYPE_AGE_BEKET.ADULTS,
  }

  if (isAbroad) {
    // preparedData.citizenship = closeCircle.citizenship.toUpperCase()
    preparedData.serialDocuments = closeCircle.document_number
  }

  // if (isChild) {
  //   preparedData.dateOfBirth = closeCircle.date_of_birth
  // }

  return preparedData
}
